import _ from "underscore";
import VueRouter from "vue-router";
import { Location, RawLocation, Route } from "vue-router/types/router";

import { RouteName } from "@/consts/route";

/**
 * ルート用ユーティリティ
 */
export class RouteUtil {
  /**
   * ルーターのpushメソッドを置き換える
   */
  public static replacePush(router: VueRouter): void {
    const originalPush: (location: RawLocation) => Promise<Route> = router.push;

    router.push = (location: RawLocation): Promise<Route> => {
      const options: Location = location as Location;

      if (!RouteUtil.isRedirectRoute(router, options)) {
        return originalPush.apply(router, [location]);
      }

      return router.replace(RouteUtil.getRedirectParams(options));
    };
  }

  /**
   * リダイレクトルートか
   */
  private static isRedirectRoute(
    router: VueRouter,
    options: Location
  ): boolean {
    return (
      _.isString(options.name) && router.currentRoute.name === options.name
    );
  }

  /**
   * リダイレクト用のパラメータを取得する
   */
  private static getRedirectParams(options: Location): Location {
    const name = options.name;
    options.name = RouteName.Redirect;
    options.params = options.params || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (options.params as any).name = name;

    return options;
  }
}
